// extracted by mini-css-extract-plugin
module.exports = {"Page":"index-module--Page--18g5L","Logo":"index-module--Logo--MT90R","Content":"index-module--Content--WP0CZ"};